// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay-wrapper {
  height: inherit;
}

.project-details {
  display: flex;
  justify-content: space-between;
  margin: 0 25px;
}
.project-details .fullkit-task-info {
  display: flex;
}
.project-details .fullkit-task-info p:not(:last-child) {
  margin-right: 40px;
}
.project-details .fullkit-task-info p span {
  text-align: center;
  color: unset;
  cursor: unset;
}
.project-details label {
  font-weight: 700;
  padding-bottom: 7px;
}
.project-details span {
  display: block;
}
.project-details button {
  display: block;
  color: #003da5;
  background: transparent;
  border: none;
}

.customFullkitName .fullkitName-height-fix {
  min-height: 53px;
  margin: 10px 5px 5px 25px;
  word-break: break-all;
}
.customFullkitName .fullkitName-height-fix [contenteditable] {
  outline: 0px solid transparent;
}
.customFullkitName .fullkitName-height-fix input[type=text] {
  outline: none;
}
.customFullkitName .fullkitName-height-fix .fullkit-container-editable {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.customFullkitName .fullkitName-height-fix .fullkit-container-editable img {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0) saturate(100%) hue-rotate(0deg);
  width: 1.5rem;
  height: 1.5rem;
  margin: 8px;
  cursor: pointer;
}
.customFullkitName .fullkitName-height-fix .fullkit-container-editable .fullkit-item {
  background-color: rgb(0, 61, 165);
  margin-bottom: 3px;
  width: fit-content;
  border-radius: 6px;
  display: flex;
  align-items: center;
}
.customFullkitName .fullkitName-height-fix .fullkit-container-editable .fullkit-item .fullkitInput {
  border: none;
  font-size: 1.25rem;
  font-weight: bold;
  color: #fff;
  background-color: rgb(0, 61, 165);
  padding: 8px 12px;
  border-radius: 6px;
  outline: none;
  min-width: 240px;
}
.customFullkitName .fullkitName-height-fix .fullkit-container {
  display: flex;
  background-color: rgb(0, 61, 165);
  border-radius: 6px;
  width: fit-content;
  justify-content: space-between;
  align-items: center;
}
.customFullkitName .fullkitName-height-fix .fullkit-container .fullkitName {
  font-size: 1.25rem;
  font-weight: bold;
  color: #fff;
  padding: 8px 12px;
}
.customFullkitName .fullkitName-height-fix .fullkit-container .edit-Icon {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0) saturate(100%) hue-rotate(0deg);
  height: 2rem;
  width: 2rem;
  margin: 8px;
  cursor: pointer;
}

.custom-fullkit-for {
  display: inline-block;
  min-width: fit-content;
  font-size: 1.2rem;
  color: rgb(0, 61, 165);
}
.custom-fullkit-for::after {
  content: "*";
  color: red;
}

.fullkit-task-header {
  background-color: rgb(237, 244, 250);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 25px;
}
.fullkit-task-header .add-file {
  color: #003da5;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  font-weight: bold;
  background: transparent;
  border: none;
}
.fullkit-task-header .add-file:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.fullkit-parentJob-details {
  overflow: hidden scroll;
  width: 100%;
  height: calc(100vh - 289px);
  padding-bottom: 50px;
}

.fullkit-parentJob-details + .form-buttons.bottom-fixed.footer-button {
  padding: 10px;
}

.fullkit-job-details {
  overflow: hidden scroll;
  width: 100%;
  height: calc(100vh - 345px);
}

.fullkit-job-details + .form-buttons.bottom-fixed.footer-button {
  padding: 10px;
}

.fullkit-task-details {
  margin: 5px 15px 20px 15px !important;
}
.fullkit-task-details .taskValueInput {
  border: 1px solid #ced4da;
}
.fullkit-task-details .error-text-di {
  color: red;
  font-weight: 800;
  font-size: 8px;
  position: relative;
}
.fullkit-task-details .mandatory-file-upload {
  line-height: 24px;
}

.mandatory-file-msg {
  margin-left: 24px;
  color: #ff0000;
}`, "",{"version":3,"sources":["webpack://./src/components/AWMJobs/CustomFullKit/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;AACJ;AACI;EACE,kBAAA;AACN;AAGM;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AADR;AAME;EACE,gBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,cAAA;AALJ;AAQE;EACE,cAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;AANJ;;AAWE;EACE,gBAAA;EACA,yBAAA;EACA,qBAAA;AARJ;AAUI;EACE,8BAAA;AARN;AAWI;EACE,aAAA;AATN;AAYI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAVN;AAYM;EACE,0FAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AAVR;AAaM;EACE,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAXR;AAaQ;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAXV;AAgBI;EACE,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AAdN;AAgBM;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AAdR;AAiBM;EACE,0FAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AAfR;;AAqBA;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;AAlBF;AAoBE;EACE,YAAA;EACA,UAAA;AAlBJ;;AAsBA;EACE,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAnBF;AAqBE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AAnBJ;AAqBI;EACE,mBAAA;EACA,YAAA;AAnBN;;AAwBA;EACE,uBAAA;EACA,WAAA;EACA,2BAAA;EACA,oBAAA;AArBF;;AAwBA;EACE,aAAA;AArBF;;AAwBA;EACE,uBAAA;EACA,WAAA;EACA,2BAAA;AArBF;;AAwBA;EACE,aAAA;AArBF;;AAwBA;EACE,qCAAA;AArBF;AAuBE;EACE,yBAAA;AArBJ;AAwBE;EACE,UAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,iBAAA;AAvBJ;;AA2BA;EACE,iBAAA;EACA,cAAA;AAxBF","sourcesContent":[".overlay-wrapper {\n  height: inherit;\n}\n\n.project-details {\n  display: flex;\n  justify-content: space-between;\n  margin: 0 25px;\n\n  .fullkit-task-info {\n    display: flex;\n\n    p:not(:last-child) {\n      margin-right: 40px;\n    }\n\n    p {\n      span {\n        text-align: center;\n        color: unset;\n        cursor: unset;\n      }\n    }\n  }\n\n  label {\n    font-weight: 700;\n    padding-bottom: 7px;\n  }\n\n  span {\n    display: block;\n  }\n\n  button {\n    display: block;\n    color: #003da5;\n    background: transparent;\n    border: none;\n  }\n}\n\n.customFullkitName {\n  .fullkitName-height-fix {\n    min-height: 53px;\n    margin: 10px 5px 5px 25px;\n    word-break: break-all;\n\n    [contenteditable] {\n      outline: 0px solid transparent;\n    }\n\n    input[type=\"text\"] {\n      outline: none;\n    }\n\n    .fullkit-container-editable {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n\n      img {\n        filter: brightness(0) saturate(100%) invert(100%) sepia(0) saturate(100%) hue-rotate(0deg);\n        width: 1.5rem;\n        height: 1.5rem;\n        margin: 8px;\n        cursor: pointer;\n      }\n\n      .fullkit-item {\n        background-color: rgba(0, 61, 165, 1);\n        margin-bottom: 3px;\n        width: fit-content;\n        border-radius: 6px;\n        display: flex;\n        align-items: center;\n\n        .fullkitInput {\n          border: none;\n          font-size: 1.25rem;\n          font-weight: bold;\n          color: #fff;\n          background-color: rgba(0, 61, 165, 1);\n          padding: 8px 12px;\n          border-radius: 6px;\n          outline: none;\n          min-width: 240px;\n        }\n      }\n    }\n\n    .fullkit-container {\n      display: flex;\n      background-color: rgba(0, 61, 165, 1);\n      border-radius: 6px;\n      width: fit-content;\n      justify-content: space-between;\n      align-items: center;\n\n      .fullkitName {\n        font-size: 1.25rem;\n        font-weight: bold;\n        color: #fff;\n        padding: 8px 12px;\n      }\n\n      .edit-Icon {\n        filter: brightness(0) saturate(100%) invert(100%) sepia(0) saturate(100%) hue-rotate(0deg);\n        height: 2rem;\n        width: 2rem;\n        margin: 8px;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.custom-fullkit-for {\n  display: inline-block;\n  min-width: fit-content;\n  font-size: 1.2rem;\n  color: rgba(0, 61, 165, 1);\n\n  &::after {\n    content: \"*\";\n    color: red;\n  }\n}\n\n.fullkit-task-header {\n  background-color: rgb(237, 244, 250);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 25px;\n\n  .add-file {\n    color: #003da5;\n    font-size: 14px;\n    font-style: normal;\n    line-height: normal;\n    font-weight: bold;\n    background: transparent;\n    border: none;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n  }\n}\n\n.fullkit-parentJob-details {\n  overflow: hidden scroll;\n  width: 100%;\n  height: calc(100vh - 289px);\n  padding-bottom: 50px;\n}\n\n.fullkit-parentJob-details+.form-buttons.bottom-fixed.footer-button {\n  padding: 10px;\n}\n\n.fullkit-job-details {\n  overflow: hidden scroll;\n  width: 100%;\n  height: calc(100vh - 345px);\n}\n\n.fullkit-job-details+.form-buttons.bottom-fixed.footer-button {\n  padding: 10px;\n}\n\n.fullkit-task-details {\n  margin: 5px 15px 20px 15px !important;\n\n  .taskValueInput {\n    border: 1px solid #ced4da;\n  }\n\n  .error-text-di {\n    color: red;\n    font-weight: 800;\n    font-size: 8px;\n    position: relative;\n  }\n\n  .mandatory-file-upload {\n    line-height: 24px;\n  }\n}\n\n.mandatory-file-msg {\n  margin-left: 24px;\n  color: #ff0000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
